import BaseProductBadge from "./BaseProductBadge.vue";

export default BaseProductBadge;
